import TextField from '@mui/material/TextField';
// import { ThemeProvider } from "@material-ui/core/styles";
import { ThemeProvider, createTheme } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
// import { createTheme } from "@material-ui/core/styles";


const theme = createTheme({
    
  overrides: {
    
  }
});

export default function CustomSearchTextField(props) {
  return (
    <ThemeProvider theme={theme}>
        <span style={{
                borderColor: '#707070',
                borderWidth:'1px',
                borderStyle: 'solid',
                borderRadius: '20px',
                width:'100%',
                height:'100%',
                display:'inline-block',
                paddingRight:'15px',
                paddingLeft:'10px',
                backgroundColor:'#fff',
                boxShadow:"0 3 6 #000000"
        }}>
        <TextField variant="standard"  
            placeholder={props.label}
            multiline={props.multiline}
            maxRows={props.multiline?4:1}
            rows={props.multiline?4:1}
            sx={{
                width:'100%',
                height:'100%',
                textAlign:'center'
            }}
            InputLabelProps={{
              style:{
                height:'100%',
                textAlign:'center'
              }
            }}
            inputProps={{style: { textAlign: 'center' }}}
            InputProps={{
              style:{
                height:'100%',
                textAlign:'center'
              },
                disableUnderline: true,
                    // startAdornment: (
                    //     <InputAdornment position="start">
                    //     {props.icon} 
                    //     </InputAdornment>
                    // ),
                    endAdornment:(
                        <InputAdornment position="start">
                         {props.icon}
                        </InputAdornment>
                    )
            }}
        />
        </span>
    </ThemeProvider>
  );
}
